"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockingContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useBlockingContentRef_1 = require("../../hooks/useBlockingContentRef");
const BlockingContent = ({ children, }) => {
    const ref = react_1.useRef(null);
    useBlockingContentRef_1.useBlockingContentRef(ref);
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children({ ref }) }, void 0);
};
exports.BlockingContent = BlockingContent;
//# sourceMappingURL=index.js.map